import React from 'react';
import {Tooltip} from "antd";

const TruncatedText = ({ text, maxLength = 15, truncateAt = 13 }) => {
    if (!text || text.length <= maxLength) {
        return <>{text}</>;
    }

    return (
        <Tooltip title={text}>
            <span>{text.slice(0, truncateAt)}...</span>
        </Tooltip>
    );
};

export default TruncatedText;